import { render, staticRenderFns } from "./BiteFormCommonFields.vue?vue&type=template&id=dd9ee292&scoped=true"
import script from "./BiteFormCommonFields.vue?vue&type=script&lang=js"
export * from "./BiteFormCommonFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9ee292",
  null
  
)

export default component.exports